module.exports = __webpack_public_path__ + "static/img/sn-53.4a2d676.gif";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/snapchat/sn-53.gif
// module id = V/qr
// module chunks = 46